export const SUPPORTED_BANKS_FOR_LINKING = [
  {
    name: "Zenith Bank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/zenith-bank-icon.png",
    alt: "Zenith Bank",
  },
  {
    name: "FCMB",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/fcmb-bank-icon.png",
    alt: "FCMB",
  },
  {
    name: "Sterling Bank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/sterling-bank-icon.png",
    alt: "Sterling Bank",
  },
  {
    name: "Stanbic IBTC Bank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/stanbic-bank-icon.png",
    alt: "Stanbic IBTC Bank",
  },
  {
    name: "Brass",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/brass_logo.jpeg",
    alt: "Brass",
  },
  {
    name: "ALAT by WEMA",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/alat-bank-icon.png",
    alt: "ALAT by WEMA",
  },
  {
    name: "Access Bank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/access-bank-icon.png",
    alt: "Access Bank",
  },
  {
    name: "United Bank For Africa",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/united-bank-africa-icon.png",
    alt: "United Bank For Africa",
  },
  {
    name: "Providus Bank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/providus-bank-icon.png",
    alt: "Providus Bank",
  },
  {
    name: "Ecobank Nigeria",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/ecobank-icon.png",
    alt: "Ecobank Nigeria",
  },
  {
    name: "Globus Bank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/globus-bank-icon.jpeg",
    alt: "Globus Bank",
  },
  {
    name: "GTBank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/gtbank-icon.png",
    alt: "GTBank",
  },
  {
    name: "Fidelity Bank",
    imageUrl:
      "https://mono-public-bucket.s3.eu-west-2.amazonaws.com/images/fidelity-bank-icon.png",
    alt: "Fidelity Bank",
  },
];
